import AuthenticationType from '@alltrails/analytics/enums/AuthenticationType';
import { GoogleLoginResponse } from 'react-google-login';
import { post } from '@alltrails/shared/api';
import LoginResponse from 'types/LoginResponse';
import { ServerCommunicationUtil } from './server_communication_util';
import { authSuccessCallback } from './AuthHandlers';
import { appleConstants } from '../Constants';

// Note: These handlers are used for both new registrations (signups) AND logins

const facebookHandler = (
  response: { accessToken: any; userID: any; expiresIn: any },
  locale: string,
  successCallback: Function = () => {},
  errorCallback = () => {},
  completeCallback = () => {},
  referralLink?: string
) => {
  if (!response.accessToken) {
    return;
  }

  const fbData = {
    facebook_id: response.userID,
    facebook_token: response.accessToken,
    facebook_expires: response.expiresIn,
    create_session: true,
    ...(referralLink && { referral_code: referralLink })
  };
  const headers = locale ? { 'X-Language-Locale': locale } : {};

  ServerCommunicationUtil.postApiEndpoint(
    '/api/alltrails/facebook/login',
    fbData,
    (data: any) => {
      authSuccessCallback(data, AuthenticationType.Facebook);
      successCallback(data);
    },
    errorCallback,
    completeCallback,
    headers
  );
};

// Note: This handler works differently than the others, where the user is redirected to
// an Apple login page and then redirected back to AllTrails.
// Because of this, there is a tracking callback implemented in GlobalActions
// that tracks that the signup/login redirect was successful.
const appleHandler = (referralLink?: string) => {
  let redirectURI = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}${
    appleConstants.REDIRECT_PATH
  }`;

  if (referralLink) {
    const params = new URLSearchParams();
    params.set('referral_code', referralLink);
    redirectURI += `?${params.toString()}`;
  }

  const authUrl = `${appleConstants.AUTHORIZE_URL + appleConstants.AUTHORIZE_PARAMS}&client_id=${
    appleConstants.CLIENT_ID
  }&redirect_uri=${encodeURIComponent(redirectURI)}&scope=${encodeURIComponent(appleConstants.SCOPES)}`;

  window.location.href = authUrl;
};

const appleRedirectHandler = () => {
  const params = new URLSearchParams(window.location.search);
  const appleOAuth = params.get('apple_oauth');
  if (appleOAuth) {
    const is_sign_up = appleOAuth === 'signup';
    authSuccessCallback({ is_sign_up }, AuthenticationType.Apple);
    const search = params.toString();
    window.history.replaceState(null, null, window.location.pathname + (search !== '' ? `?${search}` : ''));
  }
};

async function googleHandler(googleUserOrToken: GoogleLoginResponse | string, referralLink?: string, oneTap?: boolean) {
  const token = typeof googleUserOrToken === 'string' ? googleUserOrToken : googleUserOrToken.getAuthResponse().id_token;

  const data = {
    google_token: token,
    create_session: true,
    ...(referralLink && { referral_code: referralLink }),
    ...(oneTap && { one_tap: oneTap })
  };

  const response = await post<LoginResponse>('/api/alltrails/google/login', data);

  authSuccessCallback(response, oneTap ? AuthenticationType.GoogleOneTap : AuthenticationType.Google);

  return response;
}

export { facebookHandler, appleHandler, appleRedirectHandler, googleHandler };
